function utcToLocal(utcDateTime: string | Date): Date {
  const date = new Date(utcDateTime);
  const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
  const day = ('0' + date.getUTCDate()).slice(-2);
  const hours = ('0' + date.getUTCHours()).slice(-2);
  const minutes = ('0' + date.getUTCMinutes()).slice(-2);
  const seconds = ('0' + date.getUTCSeconds()).slice(-2);

  return new Date(`${date.getUTCFullYear()}-${month}-${day}T${hours}:${minutes}:${seconds}`);
}

function localToUtc(localDateTime: string | Date): Date {
  const date = new Date(localDateTime);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);

  return new Date(`${date.getFullYear()}-${month}-${day}T${hours}:${minutes}:${seconds}Z`);
}

export { utcToLocal, localToUtc };
